import React from 'react';
import EmptyState from './EmptyState';
import './Table.css';

const emptyStateConfig = {
  'No transactions found': {
    type: 'transactions',
    title: 'No Transactions Found',
    description: 'There are no transactions matching your current filters. Try adjusting your search criteria.'
  },
  'No webhooks configured': {
    type: 'webhooks',
    title: 'No Webhooks Configured',
    description: 'You haven\'t set up any webhooks yet. Add a webhook to receive transaction notifications.'
  },
  'No IP addresses whitelisted': {
    type: 'ipWhitelist',
    title: 'No IP Addresses Whitelisted',
    description: 'Your IP whitelist is empty. Add IP addresses to control access to your APIs.'
  },
  'No users found': {
    type: 'users',
    title: 'No Users Found',
    description: 'There are no users in the system yet. Add users to grant access to the platform.'
  },
  'No webhook logs found': {
    type: 'logs',
    title: 'No Webhook Logs',
    description: 'No webhook delivery attempts have been recorded yet.'
  }
};

const Table = ({
  columns,
  data,
  loading,
  emptyMessage = 'No data found',
  emptyType = 'default',
  emptyDescription = 'There are no items to display at the moment.'
}) => {
  if (loading) {
    return (
      <div className="table-loading">
        <div className="table-loader"></div>
        <span>Loading data...</span>
      </div>
    );
  }

  if (!data || data.length === 0) {
    const config = emptyStateConfig[emptyMessage] || {
      type: emptyType,
      title: emptyMessage,
      description: emptyDescription
    };

    return (
      <EmptyState
        type={config.type}
        title={config.title}
        description={config.description}
      />
    );
  }

  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} style={{ width: column.width }}>
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={row.id || rowIndex}>
              {columns.map((column) => (
                <td key={column.key}>
                  {column.render ? column.render(row[column.key], row) : row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
